import {Router} from '@angular/router';

import {CLIENT_PORTAL_ORDERS_HOME} from 'app/app.constants';
import {EntityNavigator} from 'app/blocks/routing/navigator';
import {Principal} from 'app/core/auth/principal.service';

/**
 * Order navigation that knows where the client portal's orders list actually is.
 *
 * Every "back" and post-save hop in the shared entity base classes goes through `toList()` - the back
 * buttons on the view and create/edit headers, and the redirects after create, update and delete. For an
 * admin that is the full order list; for a portal user it is the Daily Manifest, which is the only
 * orders screen their menu offers.
 */
export class HaulierOrderNavigator extends EntityNavigator {
    // Not named `_router`: EntityNavigator already declares a private field by that name, and
    // redeclaring it in a subclass makes the two types structurally incompatible.
    constructor(
        basePath: string,
        resourceName: string,
        private readonly _portalRouter: Router,
        private readonly _principal: Principal
    ) {
        super(basePath, resourceName, _portalRouter);
    }

    // toHome() delegates to toList(), so it follows this override too.
    override toList(params?: any): void {
        if (this._principal.isUserCustomer()) {
            this._portalRouter.navigate([CLIENT_PORTAL_ORDERS_HOME]);
            return;
        }
        super.toList(params);
    }

    override toListUrl(params?: any): string {
        return this._principal.isUserCustomer() ? CLIENT_PORTAL_ORDERS_HOME : super.toListUrl(params);
    }
}
